export const URLS = {
  REGISTER: 'user-management/identity/register',
  CONFIRM_REGISTRATION: 'user-management/identity/confirmRegistration',
  LOGIN: 'user-management/identity/login',
  FORBIDDEN: 'user-management/identity/login',
  FORGET_PASSWORD: 'user-management/identity/forget-password',
  CONFIRM_FORGET_PASSWORD: 'user-management/identity/confirm-forget-password',
  RESEND_OTP: 'user-management/identity/resend-otp',
  VERIFY_OTP: 'user-management/identity/verify-otp',
  CHANGE_PASSWORD: 'user-management/identity/change-password',
  LOGOUT: 'logout',
  USERS: 'user-management/users',
  FAILURE: 'user-management/identity/login',
  ATTACHMENTS: 'utility-management/attachments'
};
